import { get } from 'lodash';
import getPCRating from 'utils/get-pc-rating';

export default (itemPGRating, parentalAge) => {
  const itemRating = getPCRating(get(itemPGRating, ['name']) || get(itemPGRating, ['UA']));

  const itemRatingPriority = itemRating ? itemRating.priority : 0;
  const parentalLockAgePriority = getPCRating(parentalAge).priority;
  const noLimitation = parentalLockAgePriority === 0;

  return !noLimitation && itemRatingPriority >= parentalLockAgePriority;
};
